module.exports = __webpack_public_path__ + "img/lock-unlock.90782ab9.svg";